// English version of deletionCopy.js (Settings when the interface is in English). Keep both files in step.
export const ERRORS = {
  code_invalid: 'Invalid or expired code.',
  code_too_many_attempts: 'Too many attempts. Request a new code.',
  code_rate_limited: 'Too many codes requested. Try again in an hour.',
  code_email_failed: 'The email could not be sent. Try again.',
  password_invalid: 'Incorrect password.',
  already_requested: 'A deletion request is already in progress.',
  admin_account: 'An administration account must first hand over its rights: use “Request removal of my rights”.',
  owner_account: 'The owner account cannot be deleted until ownership of the platform has been transferred.',
  not_admin: 'This account has no administration rights.',
  no_open_request: 'No request in progress.',
  session_expired: 'Your verification has expired. Start again.',
};
export const GENERIC = 'Something went wrong. Try again.';

export const BLOCKERS = {
  token_balance: 'Token balance',
  wallet_balance: 'Wallet balance',
  staking_balance: 'Staking balance',
  active_staking: 'Active staking position',
  pending_withdrawal: 'Withdrawal in progress',
  pending_deposit: 'Deposit awaiting confirmation',
  active_hold: 'Reserved funds',
  open_escrow: 'Marketplace order in escrow or in dispute',
};

export const ACTIONS = {
  token_balance: 'Withdraw or swap this balance from the Wallet.',
  wallet_balance: 'Withdraw this balance from the Wallet.',
  staking_balance: 'Withdraw this balance from JAPAP Staking.',
  active_staking: 'Wait for the end of the term or unlock the position from JAPAP Staking.',
  pending_withdrawal: 'Wait for the withdrawal to complete.',
  pending_deposit: 'Wait for the deposit to be confirmed.',
  active_hold: 'Wait for the related operation to finish.',
  open_escrow: 'Complete the order or the dispute on the Marketplace.',
};
export const CONTACT_SUPPORT = 'Contact support.';

export const policy = (graceDays, securityDays) => ([
  {
    id: 'delay',
    title: 'Waiting period and cancellation',
    items: [
      `After confirmation, JAPAP waits ${graceDays} days before final deletion. This cancellation period is a JAPAP rule that JAPAP can adjust; it is not a Google requirement.`,
      'Cancelling requires an explicit action (the “Cancel deletion” button): signing in again cancels nothing.',
      'All your sessions are closed and notifications on your devices are switched off immediately.',
      'During this period, you can sign in again to cancel the request or settle your funds.',
    ],
  },
  {
    id: 'funds',
    title: 'Your funds remain yours',
    items: [
      'No balance is reset to zero, transferred, confiscated or forfeited.',
      'If a balance, staking position, withdrawal, deposit or escrow order is in progress, deletion is deferred, with the reason and the steps to follow.',
      'A balance too small to be withdrawn is settled with support, without any forced waiver.',
    ],
  },
  {
    id: 'deleted',
    title: 'What is deleted',
    items: [
      'Your profile: name, username, email, phone number, photo, cover, bio and professional information.',
      'Your posts, comments, reactions, stories, reels, videos, listings without orders and the related media.',
      'Your follows, followers, synchronised contacts, notifications, preferences, devices, sessions and game history.',
    ],
  },
  {
    id: 'messages',
    title: 'Messages already sent',
    items: [
      'The text and attachments of your messages are erased from our servers and replaced with “Message supprimé” (message deleted).',
      'The conversation remains visible to the other participants, with the author shown as “Deleted user”, without a link to a profile.',
      'Copies that recipients saved themselves (screenshots, downloads, forwards) are not under JAPAP’s control.',
    ],
  },
  {
    id: 'kept',
    title: 'What is kept, and why',
    items: [
      'Financial data (wallet ledger, transactions, deposits, withdrawals, staking, orders): 10 years, for accounting and tax obligations. The amounts remain; at the end, the contact details linked to the operations (Mobile Money number, address, name) are erased.',
      'Identity verification (KYC): 5 years after the account is deleted, the period required by anti-money laundering rules (UK Money Laundering Regulations 2017), then the documents are erased.',
      'Moderation, sanctions and support requests related to the deletion: 1 year, to handle appeals, disputes and requests from authorities, then erased.',
      `Security and anti-fraud logs (IP addresses, devices, refused access): ${securityDays} days, to investigate fraud or account takeover and answer authorities, then erased.`,
      'These records are no longer linked to your name, email or phone number, but to an internal identifier: they are pseudonymised (not anonymous), access is restricted and erasure at the end of the period is automatic.',
    ],
  },
]);
